export type { UserAddress } from '../../users/types/user.type';
export type { DeliveryDay } from './delivery-day.type';

export const DELIVERY_TYPES = {
  home: 'home',
  relayPoint: 'relayPoint',
  bioculture: 'bioculture',
  organization: 'organization',
} as const;
export type DeliveryType = typeof DELIVERY_TYPES[keyof typeof DELIVERY_TYPES];

export interface DeliveryAddress {
  type: 'home' | 'relay' | 'store';
  _id: string;
  address: string;
  zipCode: string;
  city: string;
  complement?: string;
  comment?: string;
  title?: string;
}
